
import {
  defineComponent,
  onMounted,
  computed,
  SetupContext,
  reactive,
  ref
} from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import HpcrRegister from '@/components/block/HpcrRegister.vue'
import DoctorRegister from '@/components/block/DoctorRegister.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import EventSimpleBox from '@/components/block/EventSimpleBox.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import ModalTerms from '@/components/block/ModalTerms.vue'

export default defineComponent({
  name: 'RegisterEventsConfirm',

  components: {
    PreviewPairData,
    GoalButtons,
    HpcrRegister,
    DoctorRegister,
    CheckboxButton,
    Button,
    HrBlock,
    TextBlock,
    ModalTerms,
    EventSimpleBox,
    HeadingLv3
  },

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const termsModal = reactive({
      isShow: false
    })
    const closeTermsModal = () => (termsModal.isShow = false)
    const openTermsModal = () => (termsModal.isShow = true)

    const store = useStore()
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    const registerEvent = store.state.registerEvent

    const selectedMemberType = store.state.master.memberType.filter(
      (option: any) => option.opt_id === props.data.memberType
    )

    const selectedArea: Array<string> = []
    store.state.master.prefectures.map((option: any) => {
      if (props.data.hopePrefectures.includes(option.opt_id))
        selectedArea.push(option.option_name)
    })

    const selectedKeywords: Array<string> = []
    store.state.master.keywords.map((option: any) => {
      if (props.data.hopeKeywords.includes(option.opt_id))
        selectedKeywords.push(option.option_name)
    })

    const selectedGender = store.state.master.gender.filter(
      (option: any) => option.opt_id === props.data.userProfile.gender
    )
    const birthdayArray = props.data.userProfile.birthday.split('/')
    const setZip = (value: string) => {
      if (!value) return ''
      return value.substr(0, 3) + '-' + value.substr(-4)
    }

    const selectedPrefecture = store.state.master.prefectures.filter(
      (option: any) => option.opt_id === props.data.userProfile.prefecture
    )
    const prefectureName =
      selectedPrefecture.length > 0 ? selectedPrefecture[0].option_name : ''

    let address = setZip(props.data.userProfile.zip)
      ? `${setZip(props.data.userProfile.zip)}<br>`
      : ''

    address += `${prefectureName}${props.data.userProfile.city}${props.data.userProfile.town}`

    let vacationAddress = ''
    if (props.data.userProfile.isEqualHolidayAddress) {
      vacationAddress = address
    } else {
      const selectedPrefectureVacation = store.state.master.prefectures.filter(
        (option: any) =>
          option.opt_id === props.data.userProfile.prefecture_vacation
      )
      const prefectureVacationName =
        selectedPrefectureVacation.length > 0
          ? selectedPrefectureVacation[0].option_name
          : ''

      vacationAddress = setZip(props.data.userProfile.zip_vacation)
        ? `${setZip(props.data.userProfile.zip_vacation)}<br>`
        : ''
      vacationAddress += `${prefectureVacationName}${props.data.userProfile.city_vacation}${props.data.userProfile.town_vacation}`
    }

    const selectedSchool = store.state.master.university.filter(
      (option: any) => option.opt_id === props.data.userProfile.school_id
    )

    const hiddenPassword = () => {
      let res = ''
      for (let i = 0; i < props.data.userProfile.password.length; i++) {
        res += '●'
      }
      return res
    }

    const confirmContents = [
      {
        label: '現在の職種',
        content: selectedMemberType[0].option_name
      },
      {
        label: '希望エリア',
        content: selectedArea.join(',')
      },
      {
        label: 'こだわり条件',
        content: selectedKeywords.join(',')
      },

      {
        label: '姓名（漢字）',
        content: `${props.data.userProfile.name_sei} ${props.data.userProfile.name_mei}`
      },
      {
        label: '姓名（カナ）',
        content: `${props.data.userProfile.kana_sei} ${props.data.userProfile.kana_mei}`
      },
      {
        label: '性別',
        content: selectedGender[0].option_name
      },
      {
        label: '生年月日',
        content: `${birthdayArray[0]}年${birthdayArray[1]}月${birthdayArray[2]}日`
      },
      {
        label: 'メールアドレス',
        content: props.data.userProfile.email
      },
      {
        label: '住所',
        content: address
      },
      {
        label: '電話番号',
        content: props.data.userProfile.tel
      },
      {
        label: '休暇中住所',
        content: vacationAddress
      },
      {
        label: '大学名',
        content: selectedSchool[0].option_name
      },
      {
        label: '卒業時期（年）',
        content: `${props.data.userProfile.graduate_year}年`
      }
    ]

    if (props.data.memberType === '2') {
      confirmContents.push({
        label: '医師免許取得年',
        content: `${props.data.userProfile.licensing_year}年`
      })
      confirmContents.push({
        label: '現勤務先',
        content: `${props.data.userProfile.work_place}`
      })

      const selectedDepartments: any = []

      for (
        let i = 0;
        i < props.data.userProfile.hoped_departments.length;
        i++
      ) {
        if (props.data.userProfile.hoped_departments[i] === '') continue

        const selected = store.state.master.departments.filter(
          (option: any) =>
            option.opt_id === props.data.userProfile.hoped_departments[i]
        )
        selectedDepartments.push(selected[0].option_name)
      }

      confirmContents.push({
        label: '希望科目',
        content: selectedDepartments.join(',')
      })
    }

    confirmContents.push({
      label: 'パスワード',
      content: hiddenPassword()
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )
    const register = () => {
      store.commit('showLoading')
      document.querySelector('form')!.submit()
    }

    interface StateObject {
      [key: string]: boolean
    }

    const flgState: StateObject = reactive({
      agree_flg: false,
      mail_magzine_flg: true,
      hpcr_regist_flg: true,
      doctor_regist_flg: true
    })

    const changeFlg = (target: string, ev: any) => {
      flgState[target] = ev.checked
    }

    const isDisabledNextBtn = computed(() => {
      return flgState.agree_flg ? false : true
    })

    const goBack = () => {
      router.push(`/register/events/profile?event_id=${props.data.event_id}`)
    }

    onMounted(() => {
      context.emit('update-flow', 4)
    })

    return {
      confirmContents,
      csrf,
      flgState,
      changeFlg,
      isDisabledNextBtn,
      register,
      registerEvent,
      goBack,
      termsModal,
      closeTermsModal,
      openTermsModal
    }
  }
})
